'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = require('decisiv-ui-utils');

var _GhostAnimation = require('./GhostAnimation');

var _GhostAnimation2 = _interopRequireDefault(_GhostAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  chrome200: function chrome200(_ref) {
    var theme = _ref.theme;
    return {
      styles: '\n      background: linear-gradient(90deg, ' + theme.colors.base.chrome200 + ' 0%,\n      ' + theme.colors.base.chrome300 + ' 16.42%,\n      ' + theme.colors.base.chrome200 + ' 100%);\n    '
    };
  },

  expanded: function expanded() {
    return {
      styles: '\n      height: ' + (0, _decisivUiUtils.px2rem)(24) + ';\n      margin: ' + (0, _decisivUiUtils.px2rem)(12) + ' ' + (0, _decisivUiUtils.px2rem)(6) + ';\n    '
    };
  },

  gapBottom: function gapBottom() {
    return {
      styles: 'margin-bottom: ' + (0, _decisivUiUtils.px2rem)(30) + ';'
    };
  },

  gapRight: function gapRight() {
    return {
      styles: 'margin-right: ' + (0, _decisivUiUtils.px2rem)(12) + ';'
    };
  },

  smallWidth: function smallWidth() {
    return {
      styles: '\n      flex: none;\n      width: ' + (0, _decisivUiUtils.px2rem)(20) + ';\n    '
    };
  },

  wide: function wide() {
    return {
      styles: '\n      width: 80%;\n    '
    };
  }
};

/* istanbul ignore next */
var styles = function styles(_ref2) {
  var theme = _ref2.theme;
  return '\n  animation: ' + _GhostAnimation2.default + ' 2s ease infinite;\n  background-size: 600% 600% !important;\n  background: linear-gradient(90deg, ' + theme.colors.base.chrome100 + ' 0%,\n              ' + theme.colors.base.chrome200 + ' 24.85%,\n              ' + theme.colors.base.chrome100 + ' 100%);\n  border-radius: ' + theme.dimensions.borderRadius + ';\n  height: ' + (0, _decisivUiUtils.px2rem)(20) + ';\n  margin: ' + (0, _decisivUiUtils.px2rem)(8) + ' ' + (0, _decisivUiUtils.px2rem)(2) + ';\n  flex: 1;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome100: _propTypes2.default.string.isRequired,
      chrome200: _propTypes2.default.string.isRequired,
      chrome300: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    borderRadius: _propTypes2.default.string.isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('GhostIndicator', _styledComponents2.default.div, styles, {
  modifierConfig: modifierConfig,
  themePropTypes: themePropTypes
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/elements/GhostIndicator/index.js
// module id = 1516
// module chunks = 2